export default __webpack_public_path__ + "static/media/login-4.ce913e58.svg";